import graphql__c65f850b959a6f2b402b from "./__generated__/PageSectionEventsList_pageSection.graphql.js";import { graphql, useFragment } from "react-relay";
import { defineMessages } from "react-intl";

import EventCard from "../Events/EventCard";
import { useFormatMessage } from "../Intl/Context";
import PageSectionBlockWithTitleAndDescription from "./PageSectionBlockWithTitleAndDescription";

const PageSectionEventsList = props => {
  const pageSection = useFragment(PageSectionEventsList_pageSection, props.pageSection);
  const { title, description, events, hideIfEmpty } = pageSection;

  const t = useFormatMessage();
  const noEvents = t(intlMessages.noEvents);

  if (!events.length && hideIfEmpty) return null;

  return (
    <PageSectionBlockWithTitleAndDescription
      title={title}
      description={description}
      iconClassName="icon-calendar"
    >
      {events.length ? (
        <div className="row cards-row">
          {events.map(event => (
            <div key={event.id} className="col-lg-6">
              <EventCard participativeModule={event} />
            </div>
          ))}
        </div>
      ) : (
        <div className="bg-gray text-default">{noEvents}</div>
      )}
    </PageSectionBlockWithTitleAndDescription>
  );
};

const PageSectionEventsList_pageSection = graphql__c65f850b959a6f2b402b;

export default PageSectionEventsList;

const intlMessages = defineMessages({
  noEvents: {
    id: "events.list.noEvents",
    defaultMessage: "Aucun évènement n'est prévu pour le moment."
  }
});
